import axios from 'axios'

const MELI_NEIGHBORHOODS_ENDPOINT = " https://api.mercadolibre.com/classified_locations/cities"

export default async function getNeighborhoods (city_ID) {
    const response = await axios.get(`${MELI_NEIGHBORHOODS_ENDPOINT}/${city_ID}`)
    if (response.status === 200) {
        return response.data.neighborhoods
    }
    return null

}